<template>
  <div class="comboDialog">
    <el-dialog title="选择可导出项" width="82%" :visible.sync="visible">
      <rtas-choose v-show="type === '1'"></rtas-choose>
    </el-dialog>
  </div>
</template>

<script>
  import bus from './bus'
  import rtasChoose from './comboChoose'

    export default {
        name: "comboDialog",
        components:{
            rtasChoose
        },
        data(){
          return {
            /*控制开关*/
            visible:false,
            /*控制显示内容*/
            type:'1'
          }
        },
        methods:{

        },
        created(){
          bus.$on('filterFind',()=>{
            this.visible = true;
          });
          bus.$on('chooseType',()=>{
            this.visible = false;
          });
        }
    }
</script>

<style scoped>

</style>

<style>
  .comboDialog .el-dialog{
    min-width: 1200px !important;
    height: 70% !important;
  }
  .comboDialog .el-dialog__body{
    padding: 0 !important;
    height: calc(100% - 54px);
  }
</style>



// WEBPACK FOOTER //
// src/exportData/comboDialog.vue